import { WatchlistActions } from '@unistocks/features/watchlists/store/watchlist.slice';
import { useWatchlistsGetListQuery } from '@unistocks/proxy/axios-client/WatchlistsQuery';
import { useAppDispatch } from '@unistocks/shared/hooks/redux-hooks';
import { t } from '@unistocks/shared/localization/index.ts';
import { Stack, useRouter } from 'expo-router';
import { useEffect } from 'react';

export const unstable_settings = {
  anchor: 'index'
};

export default function WatchlistsLayout() {
  const dispatch = useAppDispatch();
  const router = useRouter();
  const { data: watchlists, isSuccess } = useWatchlistsGetListQuery();

  // Sync watchlist state with redux
  useEffect(() => {
    if (isSuccess) {
      dispatch(WatchlistActions.syncWatchlistState(watchlists));

      if (!watchlists.items.length) router.replace('/(tabs)/watchlists/create');
    }
  }, [dispatch, isSuccess, router, watchlists]);

  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: 'transparent' }
      }}
    >
      <Stack.Screen name="index" options={{ title: t('::Menu:Watchlists') }} />
      <Stack.Screen name="[id]/index" options={{ title: t('::Watchlist') }} />
      <Stack.Screen
        name="[id]/add-asset"
        options={{ title: t('::AddWhat', { 0: t('::Holdings').toLowerCase() }) }}
      />
      <Stack.Screen name="create" options={{ title: t('::Menu:Watchlists:Create') }} />
    </Stack>
  );
}
